import { Button, Stack } from '@mui/material';
import * as React from 'react';
import Barcode from 'react-barcode';
import { QRCode } from 'react-qrcode-logo';
import { logoColor } from '../../../../helpers/ImagesUtils';

const CodeQrComponent = ({
  id,
  download = false,
  maxWidth = '140',
  value,
  logo = false,
  type = 'qr',
  qrRef,
}) => {
  const ids = `codeqr-${id}`;

  const downloadCode = () => {
    const canvas = document.getElementById(ids);
    if (canvas) {
      const pngUrl = canvas
        .toDataURL('image/png')
        .replace('image/png', 'image/octet-stream');
      let downloadLink = document.createElement('a');
      downloadLink.href = pngUrl;
      downloadLink.download = `QR-${id}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  return type === 'bar' ? (
    <div
      style={{
        height: 'auto',
        margin: '0 auto',
        maxWidth: maxWidth,
        width: '100%',
      }}
    >
      <Stack ref={qrRef} direction="column" alignItems="center">
        <Barcode
          id={ids}
          height={60}
          width={2}
          displayValue={false}
          value={value}
        />
        {download && (
          <Button
            size="small"
            variant="text"
            onClick={downloadCode}
            sx={{ mt: 1 }}
          >
            Descargar
          </Button>
        )}
      </Stack>
    </div>
  ) : (
    <div
      style={{
        height: 'auto',
        margin: '0 auto',
        maxWidth: maxWidth,
        width: '100%',
      }}
    >
      <Stack ref={qrRef} direction="column" alignItems="center">
        <QRCode
          value={value} // here you should keep the link/value(string) for which you are generation promocode
          size={maxWidth} // the dimension of the QR code (number)
          logoImage={logo ? logoColor : null} // URL of the logo you want to use, make sure it is a dynamic url
          logoHeight={40}
          logoWidth={40}
          logoOpacity={1}
          quietZone={3}
          bgColor="transparent"
          // enableCORS={true} // enabling CORS, this is the thing that will bypass that DOM check
          qrStyle="circle" // type of qr code, wether you want dotted ones or the square ones
          eyeRadius={0} // radius of the promocode eye
          id={ids}
        />

        {download && (
          <Button
            size="small"
            variant="text"
            onClick={downloadCode}
            sx={{ mt: 1 }}
          >
            Descargar
          </Button>
        )}
      </Stack>
    </div>
  );
};

export default CodeQrComponent;
